/**
 * Detects the template version of a vendor specification
 * V1: No config.template_type or config.template_type === "v1" (legacy)
 * V2: config.template_type === "v2" (new structure)
 */
export const detectTemplateVersion = (vendorSpec: any): 'v1' | 'v2' => {
  // Check if it's explicitly marked as v2
  if (vendorSpec?.config?.template_type === 'v2') {
    return 'v2';
  }

  // Check if it's explicitly marked as v1
  if (vendorSpec?.config?.template_type === 'v1') {
    return 'v1';
  }

  // Check if any vendor_endpoints have v2 template_type
  if (vendorSpec?.vendor_endpoints) {
    const hasV2Endpoint = vendorSpec.vendor_endpoints.some(
      (ep: any) => ep.source_template?.template_type === 'v2',
    );
    if (hasV2Endpoint) {
      return 'v2';
    }
  }

  // Default to v1 (legacy)
  return 'v1';
};

export const isV2Template = (vendorSpec: any): boolean => {
  return detectTemplateVersion(vendorSpec) === 'v2';
};
